import { Card } from 'antd';

import { SettingsTable } from '../../components/Settings/SettingsTable';
import { TitleBreadcrumbs } from '../../uiComponents/TitleBreadcrumbs';

export const Settings = () => {
  return (
    <Card title={<TitleBreadcrumbs />} bordered={true} className="gx-card">
      <SettingsTable />
    </Card>
  );
};
